// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7149) return "static/chunks/7149-06604cdca62e6778.js";
	if (chunkId === 7012) return "static/chunks/7012-52aac89dc81b91b7.js";
	if (chunkId === 5140) return "static/chunks/5140-f04d896b72f022e4.js";
	if (chunkId === 9724) return "static/chunks/9724-93b192fbd67c1e23.js";
	if (chunkId === 1356) return "static/chunks/1356-c0c71a42c14b185c.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"4991":"d320e741","7753":"fc2f6fa8"}[chunkId] || chunkId) + "." + {"290":"90bac8243cbbf023","1646":"314724838722bc18","3705":"8c64ce85b1884c65","3721":"81c757fa5eaf8280","4991":"b7917a69817bfc03","5139":"3af505ae0c727fe9","5737":"348fa1f96447cb44","7753":"3cc53f9e3148de5c"}[chunkId] + ".js";
};